import React from "react";
import { Link } from "react-router-dom";

import classes from "./Button.module.scss";

const Button = (props) => {
  let colors = props.colors
    ? props.colors.length > 1
      ? props.colors
      : [props.colors[0], props.colors[0]]
    : ["#329d9c", "#cff4d2"];

  const style = {
    background: `linear-gradient(to bottom right, ${colors.join(",")})`,
    boxShadow: props.noShadow ? "" : "0px 4px 4px rgba(0, 0, 0, 0.25)",
    padding: props.path ? "0" : "10px 15px",
    ...props.style
  };
  let link = props.path ? (
    <Link className={classes.link} to={props.path}>
      {props.children}
    </Link>
  ) : (
    props.children
  );
  return (
    <button onClick={props.click} className={classes.button} style={style}>
      {link}
    </button>
  );
};

export default Button;
